import React, { memo } from "react";
import { Autocomplete, FormControl, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

/**
 * Organization selector component
 */
const OrganizationSelector = ({
  organisations,
  selectedOrganisation,
  onChange,
  themeMode,
  theme,
}) => {
  const { t } = useTranslation("common");

  return (
    <FormControl variant="standard" sx={{ minWidth: 250, mr: 1 }}>
      <Autocomplete
        id="organisation-select"
        options={organisations || []}
        getOptionLabel={(option) => option?.name || ""}
        getOptionKey={(option) => option?.id || ""}
        value={selectedOrganisation?.value || selectedOrganisation || null}
        isOptionEqualToValue={(option, value) => {
          // Handle both direct objects and nested value objects
          const valueToCompare = value?.value || value;
          return option?.id === valueToCompare?.id;
        }}
        loading={!organisations || organisations.length === 0}
        loadingText={t("common.loading")}
        noOptionsText={t("common.no_organisations")}
        onChange={(event, newValue) => onChange(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            sx={{
              "& .MuiInput-input": {
                color:
                  themeMode === "dark" ? theme.palette.primary.main : "white",
              },
              "& .MuiInputLabel-root": {
                color:
                  themeMode === "dark" ? theme.palette.primary.main : "white",
              },
              "& .MuiSvgIcon-root": {
                color:
                  themeMode === "dark" ? theme.palette.primary.main : "white",
              },
            }}
          />
        )}
      />
    </FormControl>
  );
};

OrganizationSelector.propTypes = {
  organisations: PropTypes.array,
  selectedOrganisation: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  themeMode: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
};

export default memo(OrganizationSelector);
